import InvoiceReport from '../invoice/InvoiceReport';
import ExpenseReport from '../expense/ExpenseReport';
import VoucherReport from '../voucher/VoucherReport';
import WalletClientModal from '../wallet/WalletClientModal';
import type { DepositPickItem } from './DepositPickList';

export type DepositSourceView =
	| { kind: 'sale'; batch: string }
	| { kind: 'expense'; id: number }
	| { kind: 'voucher'; id: number; code?: string }
	| { kind: 'wallet'; client_id: number; client: string };

export const sourceViewFromPickItem = (item: DepositPickItem): DepositSourceView | null => {
	if ((item.kind === 'payment' || item.kind === 'refund') && item.batch) {
		return { kind: 'sale', batch: item.batch };
	}
	if (item.kind === 'expense' && item.id) {
		return { kind: 'expense', id: item.id };
	}
	if ((item.kind === 'change' || item.kind === 'voucher') && item.id) {
		return { kind: 'voucher', id: item.id, code: item.code };
	}
	if ((item.kind === 'wallet' || item.kind === 'wallet_debit') && item.client_id) {
		return { kind: 'wallet', client_id: item.client_id, client: item.client || '' };
	}
	return null;
};

type Props = {
	view: DepositSourceView | null;
	onClose: () => void;
};

const DepositSourceReports = ({ view, onClose }: Props) => (
	<>
		{view?.kind === 'sale' && (
			<InvoiceReport isOpen toggle={onClose} bundle={{ batch: view.batch }} />
		)}
		{view?.kind === 'expense' && (
			<ExpenseReport isOpen toggle={onClose} bundle={{ id: view.id }} />
		)}
		{view?.kind === 'voucher' && (
			<VoucherReport
				isOpen
				toggle={onClose}
				bundle={{ id: view.id, code: view.code || '', amount: 0, status: 'ACTIVE' } as any}
			/>
		)}
		{view?.kind === 'wallet' && (
			<WalletClientModal
				isOpen
				wallet={{
					client_id: view.client_id,
					client: view.client,
					balance: 0,
					is_active: true,
				}}
				onClose={onClose}
			/>
		)}
	</>
);

export default DepositSourceReports;
